class TemplateParser {

	static parse(templateString:string):Template {

		var root:Template = new Template();

		var template:Template = root;

		var regex        = /<(tplnot|tpl)\s.*?id="(.*?)".*?>|<\/(tplnot|tpl)>|\[(.*?)\]/ig;
		var match        = regex.exec(templateString);
		var currentIndex = 0;

		while (match != null) {

			// The bit between the last match and the current match is a piece of text.
			// Note that it may be empty, but we don't really care about that.
			var previousTextPart = templateString.substring(currentIndex, match.index);
			template             = template.handleText(previousTextPart);
			template             = template.handleText(match[0]);

			currentIndex = regex.lastIndex;
			match        = regex.exec(templateString);

		}

		root.handleText(templateString.substring(currentIndex));
		return root;
	};

}

export class Template implements TemplatePart {

	static fromString(templateString:string):Template {
		return TemplateParser.parse(templateString);
	}

	private parts:TemplatePart[] = [];
	private knownPlaceholders:string[] = [];

	getKnownPlaceholders() {
		return this.knownPlaceholders;
	}

	handleText(text:string):Template {

		var conditional = TemplatePartConditional.create(this, text);
		if (conditional != null) {

			this.parts.push(conditional);
			this.knownPlaceholders.push(conditional.getId());
			return conditional;

		} else if (text.charAt(0) == '[' && text.charAt(text.length - 1) == ']') {

			const placeholder = new TemplatePartPlaceholder(text.substring(1, text.length - 1));
			this.parts.push(placeholder);
			this.knownPlaceholders.push(placeholder.getName());
			return this;

		} else {

			this.parts.push(new TemplatePartText(text));
			return this;

		}

	}

	evaluate(placeholders:PlaceholderCollection):string {
		var template:string = "";
		this.parts.forEach(function (part) {
			template += part.evaluate(placeholders)
		});
		return template;
	}

	addKnownPlaceholders(placeholders:string[]):void {
		placeholders.forEach((placeholder) => {
			this.knownPlaceholders.push(placeholder);
		});
	}
}

class TemplatePartConditional extends Template {

	static create(parent:Template, text:string):TemplatePartConditional|null {

		var conditionalRegex = /<(tplnot|tpl)\s.*?id="(.*?)".*?>/;
		var conditionalMatch = text.match(conditionalRegex);

		if (conditionalMatch == null) {
			return null;
		}
		var id       = conditionalMatch[2];
		var inverted = conditionalMatch[1].toLocaleLowerCase() == "tplnot";

		var valueRegex = /value="(.*?)"/;
		var valueMatch = text.match(valueRegex);

		var conditional = valueMatch == null
				? new TemplatePartConditional(parent, id)
				: new TemplatePartConditionalValue(parent, id, valueMatch[1]);

		if (inverted) {
			conditional.invert();
		}

		return conditional;
	}

	inverted:boolean = false;

	constructor(protected parent:Template, protected id:string) { super() }

	getId() {
		return this.id;
	}

	handleText(text:string):Template {
		const isTplNot = text == "</tplnot>";
		const isTpl = text == "</tpl>";
		if ( isTplNot && !this.inverted || isTpl && this.inverted) {
			// Note that at time of writing, we don't have a way to get javascript errors to notify developers.
			// However, this should get picked up by deployment at the time that templates are changed, when they
			// try to view the template and it doesn't work.
			throw new Error("Mismatching tpl/tplnot tags when parsing template.");
		}

		if (isTplNot || isTpl) {
			this.parent.addKnownPlaceholders(this.getKnownPlaceholders());
			return this.parent;
		}

		return super.handleText(text);
	}

	invert() {
		this.inverted = true;
	}

	matches(value:string|null) {
		// Inspired by the PHP "contentAsBool" method in inner template manager.
		return value != null && value.toString().length > 0 && value.toString() != "0";
	}

	evaluate(placeholders:PlaceholderCollection):string {

		const value   = placeholders.hasOwnProperty(this.id) ? placeholders[this.id] : null;
		const matches = this.matches(value);

		if ((matches && !this.inverted) || (!matches && this.inverted)) {
			return super.evaluate(placeholders)
		} else {
			return "";
		}

	}

}

class TemplatePartConditionalValue extends TemplatePartConditional {

	constructor(parent:Template, protected id:string, protected expectedValue:string) {
		super(parent, id)
	}

	matches(value:string):boolean {
		return value == this.expectedValue
	}
}

class TemplatePartText implements TemplatePart {

	constructor(public text:string) {}

	evaluate(placeholders:PlaceholderCollection):string {
		return this.text
	}
}

class TemplatePartPlaceholder implements TemplatePart {

	constructor(protected name:string) {}

	getName() {
		return this.name;
	}

	evaluate(placeholders:PlaceholderCollection):string {
		var value = placeholders.hasOwnProperty(this.name) ? placeholders[this.name] : null;
		return value != null ? value : '';
	}

}



// WEBPACK FOOTER //
// ./src/innertemplatemanager/Template.ts